import { Actions, thunk } from 'easy-peasy';
import { IStoreModel } from '~/store/types';
import api from '~/services/api';
import { IUserRole } from '~/types';
import getAccessibleTeamIdsForClinic from '../getAccessibleTeamIdsForClinic';
import { IActTeamActions, IThunkGetActTeamsAvailable } from '../types';

const onGetActTeamsAvailable: IThunkGetActTeamsAvailable = thunk(
  async ({ setAvailableActTeams }: Actions<IActTeamActions>, payload, { getStoreState }) => {
    const { clinicId } = payload;
    const store = getStoreState() as IStoreModel;
    const { current } = store.user;

    const currentRole = current?.roles?.find(
      role => role.id === current.roleId && role.clinic?.id === Number(clinicId),
    );
    const currentUserRole = current?.roles?.find(
      role => role.id === current?.roleId && role.clinic?.id === current?.clinic?.id,
    );
    const isSuperAdmin = currentUserRole?.name === IUserRole.SuperAdmin;
    const isLocalAdmin = currentRole?.name === IUserRole.LocalAdmin;
    const teamIdsInClinic = getAccessibleTeamIdsForClinic(current, clinicId, currentRole);

    const { data } = await api.actTeam.getActTeamsAvailable(clinicId);

    setAvailableActTeams(
      isLocalAdmin || isSuperAdmin ? data : data.filter(team => teamIdsInClinic.includes(team.id)),
    );
  },
);

export default onGetActTeamsAvailable;
